import Vue from "vue";

import Vuerouter from "vue-router";

// import Clientlist from "../views/ClientList.vue";
import Clients from "@/views/Clients";
import ProductsMain from "../views/Products/ProductsMain.vue";
// import CardList from "../views/CardList.vue";
import Balance from "@/views/Balance";
import Trainers from "@/views/Trainers";
import Profile from "@/views/Profile";
import Marketing from "@/views/Marketing";
import Schedule from "@/views/Schedule";
import Groups from "@/views/Groups";
import Login from "@/views/Login";
import store from "../store";
import Visits from "@/views/Visits";
import Facilities from "@/views/Facilities";
import AnalyticsMain from "../views/Analytics/AnalyticsMain.vue";
// import Client from "@/components/Client";

Vue.use(Vuerouter);

const routes = [
  {
    path: "/clients/:id?",
    name: "Clients",
    // component: Clientlist,
    component: Clients,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/",
    name: "Login",
    component: Login,
  },
  {
    path: "/cards",
    name: "Cards",
    component: ProductsMain,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/visits",
    name: "Visits",
    component: Visits,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/trainers",
    name: "Trainers",
    component: Trainers,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/balance",
    name: "Balance",
    component: Balance,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/profile",
    name: "Profile",
    component: Profile,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/marketing",
    name: "Marketing",
    component: Marketing,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/analytics",
    name: "Analytics",
    component: AnalyticsMain,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/schedule",
    name: "Schedule",
    component: Schedule,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/groups",
    name: "Groups",
    component: Groups,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/facilities",
    name: "Facilities",
    component: Facilities,
    meta: {
      requiresAuth: true,
    },
  },
];

const router = new Vuerouter({
  scrollBehavior() {
    return {
      x: 0,
      y: 0,
    };
  },
  mode: "history",
  routes,
});

router.beforeEach((to, from, next) => {
  if (to.matched.some((record) => record.meta.requiresAuth)) {
    if (!store.getters.isAuth) {
      next({
        path: "/login",
        query: { redirect: to.fullPath },
      });
    } else {
      next();
    }
  } else {
    next();
  }
});

export default router;
